/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */

const addDefaultType = (someObject) => {
    // not adding a type when the object has a $ref
    if (!someObject.$ref && !someObject.type) {
        someObject.type = 'string';
    }

};

const fixIncompleteSchema = schema => {
    if (schema.type === 'array') {
        if (!schema.items) {
            schema.items = {};
            addDefaultType(schema.items);
        } else {
            if (Array.prototype.isPrototypeOf(schema.items)) {
                if (schema.additionalItems) {
                    addDefaultType(schema.additionalItems);
                }
                schema.items.forEach(fixIncompleteSchema);

            } else if (typeof schema.items === 'object') {
                addDefaultType(schema.items);
                fixIncompleteSchema(schema.items);
            }
        }
    } else if (schema.type === 'object' && schema.properties) {
        Object.values(schema.properties).map(fixIncompleteSchema);
    }
    if (schema.definitions) { // fixing incomplete definitions
        Object.values(schema.definitions).map(fixIncompleteSchema);
    }
};

export { fixIncompleteSchema };